import axios from "axios";

const state = {
    counts: [],
	counts_object: {}
};

const actions = {

    async loadCounts(context){
        return axios.get("/api/countinfo").then(function(response){
            console.log("response",response)
			context.commit("setCounts", response.data);
        })
    },


}

const mutations = {

    setCounts(state,data){
        state.counts = data;

		var newObject = {}
		for(var i=0; i<data.length; i++){
			newObject[data[i].count_item] = data[i].count_total
		}

		state.counts_object = newObject

    },

}

const getters = {
    counts(state){
        return state.counts;
    },

	counts_object(state){
        return state.counts_object;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};
